// components/maintenance/MaintenancePage.tsx
// ENKEL VERSJON MED LOGG UT-KNAPP

import React from 'react';
import { Settings, Clock, AlertTriangle, LogOut } from 'lucide-react';

interface MaintenancePageProps {
  maintenanceStatus?: {
    enabled?: boolean;
    message?: string;
    start_time?: string;
    estimated_end?: string;
    set_by?: string;
  };
  onLogout?: () => void;
}

const MaintenancePage: React.FC<MaintenancePageProps> = ({ 
  maintenanceStatus,
  onLogout 
}) => {
  const handleLogout = () => {
    // Fjern all autentisering
    localStorage.removeItem("hagia-user-name");
    localStorage.removeItem("hagia-user-pin");
    localStorage.removeItem("hagia-login-time");
    localStorage.removeItem("hagia-last-activity");
    
    // Refresh siden for å gå tilbake til login
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full mx-4">
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          <div className="mb-6">
            <Settings className="mx-auto h-16 w-16 text-orange-500 animate-spin" style={{
              animation: 'spin 3s linear infinite'
            }} />
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            Vedlikehold pågår
          </h1>
          
          <p className="text-gray-600 mb-6">
            {maintenanceStatus?.message || 'Systemvedlikehold pågår. Vi er tilbake snart!'}
          </p>
          
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
            <div className="flex items-start space-x-2">
              <AlertTriangle className="h-5 w-5 text-yellow-600 mt-0.5" />
              <div className="text-sm text-yellow-800">
                <p className="font-semibold mb-1">Viktig informasjon:</p>
                <ul className="text-left space-y-1">
                  <li>• Ikke oppdater eller lukk nettleseren</li>
                  <li>• Du blir automatisk omdirigert når vedlikeholdet er ferdig</li>
                  <li>• Kontakt support ved kritiske problemer</li>
                </ul>
              </div>
            </div>
          </div>
          
          {/* LOGG UT KNAPP - ALLTID SYNLIG */}
          <button
            onClick={onLogout || handleLogout}
            className="w-full bg-red-600 text-white py-3 px-4 rounded-lg hover:bg-red-700 transition-colors font-semibold flex items-center justify-center space-x-2"
          >
            <LogOut className="h-5 w-5" />
            <span>Logg ut</span>
          </button>
          
          <p className="text-xs text-gray-500 mt-4">
            Er du administrator? Logg ut og logg inn igjen med admin-konto for å avslutte vedlikehold.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;